export default __webpack_public_path__ + "static/media/question-mark.a62cd50f.svg";